import React, { Component, ReactNode } from 'react';
import EmoticonCryOutlineIcon from 'mdi-react/EmoticonCryOutlineIcon';

import { EmptyState } from '@crm-framework/empty-state';

import { IErrorBoundaryProps, IErrorBoundaryState } from './types';
import { ErrorWrapper } from './styles';

export class ErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  private constructor(props: IErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  public componentDidCatch(): void {
    this.setState({ hasError: true });
    // TODO Log to server.
  }

  public render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorWrapper>
          <EmptyState
            icon={EmoticonCryOutlineIcon}
            header="Oops! Something went wrong."
            description="Please contact your administrator or try to refresh this page later."
          />
        </ErrorWrapper>
      );
    }

    return children;
  }
}
